import { CapacityDetails, CapacityHealth, CapacitySummary } from 'capacity/types'
import {
    CapacityGateway,
    CapacityMembers,
    CapacityNotSupportedError,
    GatewayCapabilities,
    SavePlan,
    SaveResult,
    TodayUsage,
} from './capacityGateway'

export const SERVER_CAPABILITIES: GatewayCapabilities = {
    members: 'server',
    optionItemsCap: null,
    atomicSave: true,
    delete: true,
    usage: 'server',
    health: 'server',
}

const notImplemented = (ticket: string, endpoint: string) =>
    new CapacityNotSupportedError(ticket, `${endpoint} is not available yet (${ticket})`)

export class ServerCapacityGateway implements CapacityGateway {
    readonly capabilities = SERVER_CAPABILITIES

    listCapacities(): Promise<CapacitySummary[]> {
        throw notImplemented('BUIL-801', 'GET v1/resources with a health field')
    }

    getCapacity(): Promise<CapacityDetails> {
        throw notImplemented('BUIL-801', 'GET v1/resources/{id} with a health field')
    }

    getMembers(): Promise<CapacityMembers> {
        throw notImplemented('BUIL-798', 'GET availability_pools/{poolId}/products/')
    }

    save(): Promise<SaveResult> {
        throw notImplemented('BUIL-799', 'PUT availability_pools/{poolId}/products/')
    }

    deleteCapacity(): Promise<void> {
        throw notImplemented('BUIL-800', 'DELETE v1/resources/{id}')
    }

    getTodayUsage(): Promise<Record<string, TodayUsage>> {
        throw notImplemented('BUIL-803', 'the per-capacity usage summary')
    }

    getHealth(): CapacityHealth {
        throw notImplemented('BUIL-801', 'the capacity health field')
    }
}

export type { SavePlan }
